import { gql } from "@apollo/client";

export const GET_DATOS_GENERALES_RI_BY_ID = gql`
  query DatosGeneralesRIByID (
    $idDatosGenerales: Int!
  ){
    datosGeneralesRIByID (
      idDatosGenerales: $idDatosGenerales
    ){
      datosGeneralesRINavigation{
        idDatosGeneralesRI
        idPaciente
        centroReferencia
        codInstitucionReferencia
        idComboRIValorLugarServicio
        idComboRIValorLugarRI
        servicioEmergencia
        telefonoEmergencia
        tipoModuloRI{
          idTipoModulo
        }
          
        resumenHCL
        diagnosticoAlta
        diagnosticoRI{
          idDiagnostico
          idItemDiagnostico
          idItemDiagnosticoNavigation{
            descripcion
          }
        }
        enfermedadOncologica
        antecedenteClinicoRI{
          idComboRIValor
        }
        otrosAntecedentes
        comentarioRelevante
        alergiaRI{
          idAlergia
        }
        otrasAlergias
        medicacionHabitual
        estableHemodinamicamente
        estableEnfermedad
        nivelConciencia
        escaras
        ostomias
        otrosRelevantes
        pesoActual
        talla
        idComboRIValorNivelActividad
        idComboRIValorAduPerdidaPeso
        aduPesoHabitual
        idComboRIValorAduEvaluado
        aduIMC
        aduPerdidaPeso
        idComboRIValorAduGradoDesnutricion
        idComboRIValorAduDiagnosticoNutricional
        idComboRIValorAduMetaNutricional
        pedCircunferenciaMBraquial
        pedZScoreTalla
        pedZScorePeso
        pedZScoreIMC
        idComboRIValorPedDiagnosticoNutricional
        idComboRIValorPedMetaSoporteNutricional
        requerimientosExtraNutricionalesRI{
          idComboRIValor
        }
        justificacionSoporteRI {
          idComboRIValor
        }
      }
      datosFiliatorios{
        hC
        nombre
        apellido
        dNI
        fechaNacimiento
        edad
        sexo
        domicilio
        domicilioRI
        habitacionRI
        financiador
        nroAfiliado
        telContacto
        familiarContacto
        telFamiliar
        medicoPrescriptor
        localidadRI
        provinciaRI
        codigoPostalRI
      }
    }
  }
`;